import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import commonStrings from '../../constants/commonStrings';

const AccountTypes = {
  card: 'card',
  ach: 'ach',
  all: 'all',
};

// enter the accounts you need or have it filter the accounts based on the type?
const SelectAccount = (props) => {
  const { paymentMethods, selectAccount, selectedAccount, showType = AccountTypes.all } = props;
  const { t } = useTranslation();
  const dropDownLabel = showType === AccountTypes.ach ? t('SelectACHPaymentMethod') : t('SelectPaymentMethod');

  const handleChangeDropDown = (e, val) => {
    selectAccount(val);
  };

  const getLabel = (account) => {
    return account?.paymentType?.toLowerCase() === AccountTypes.ach
      ? `${account?.bankName || 'Bank'} - ${account?.accountType || 'ACH'} - ${
          account?.maskedValue || account?.maskedAccountNumber || '****'
        }`
      : `${account?.accountType || 'N/A'} - ${account?.creditOrDebit || account?.paymentType || 'Card'} - ${
          account?.maskedValue || account?.maskedAccountNumber || '****'
        }`;
  };

  const displayMethods = React.useMemo(() => {
    if (!Array.isArray(paymentMethods)) {
      return [];
    }

    return paymentMethods
      .map((account) => {
        const label = getLabel(account);
        return { ...account, label: label };
      })
      .filter((account) => {
        switch (showType) {
          case AccountTypes.ach:
            if (account.paymentType?.toLowerCase() === AccountTypes.ach) {
              return account;
            }
            break;
          case AccountTypes.card:
            // or !ach
            if (
              [commonStrings.credit, commonStrings.debit, commonStrings.card].includes(
                account.paymentType?.toLowerCase()
              )
            ) {
              return account;
            }
            break;
          default:
            return account;
        }
      });
  }, [paymentMethods, showType]);

  const displaySelectedAccount = React.useMemo(() => {
    let display = null;
    if (selectedAccount && Object.keys(selectedAccount)?.length > 0) {
      const label = getLabel(selectedAccount);
      display = { ...selectedAccount, label: label };
    }
    return display;
  });

  return (
    <Grid item xs={12} sm={12} md={12}>
      <Autocomplete
        id="selectAccount"
        options={displayMethods}
        value={displaySelectedAccount} // used to help clear the selected option, not required to work
        renderInput={(params) => <TextField {...params} label={dropDownLabel} />}
        isOptionEqualToValue={(option, value) =>
          !value.gatewayPaymentMethodId ||
          (option.gatewayPaymentMethodId === value.gatewayPaymentMethodId && option.paymentType === value.paymentType)
        }
        onChange={(e, val) => handleChangeDropDown(e, val)}
      />
    </Grid>
  );
};

SelectAccount.propTypes = {
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      paymentMethodId: PropTypes.string,
      gatewayPaymentMethodId: PropTypes.string.isRequired,
      paymentType: PropTypes.string.isRequired,
      bankName: PropTypes.string,
      accountType: PropTypes.string,
      maskedValue: PropTypes.string,
      maskedAccountNumber: PropTypes.string, // alternative for newer PaymentDetailsDTO type
      creditOrDebit: PropTypes.string,
    })
  ).isRequired,
  selectAccount: PropTypes.func,
  selectedAccount: PropTypes.any,
  showType: PropTypes.string,
};

export default SelectAccount;
